import React from 'react';
import classes from './reviewCard.module.css';
import Stars from '../../../../assets/images/stars.png';
import { getImageUrl } from '../../../../utils/imageUrl';

const ReviewCard = ({ review }) => {
    return (
        <div className={classes.Container}>
            <div className={classes.Header}>
                {review.image && <img
                    className={classes.Image}
                    src={getImageUrl(review.image)}
                    alt={review.name}
                />}
                <div>
                {review.name && <div className={classes.Name}>{review.name}</div>}
                    {review.platform && <div className={classes.Role}>{review.platform}</div>}
                </div>
            </div>
            {review.comment && <div className={classes.Review}>{review.comment}</div>}
            <div className={classes.Rating}>
            {review.date && <div className={classes.Date}>{review.date}</div>}
            {review.rating && <div className={classes.Stars}>
                    {review.rating}&nbsp;<img src={Stars} alt='stars' />
                </div>}
            </div>
        </div>
    );
};

export default ReviewCard;
